var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01651 6C5.65043 6 5.30856 6.17066 5.10549 6.45477L2.18573 10.5399C1.70065 11.2186 2.22225 12.1277 3.09675 12.1277H3.51444V17.234C3.51444 17.6571 3.8821 18 4.33562 18C4.78915 18 5.15681 17.6571 5.15681 17.234V12.1277H6.79917V14.6809C6.79917 15.1039 7.16683 15.4468 7.62036 15.4468C8.07388 15.4468 8.44154 15.1039 8.44154 14.6809V12.1277H15.5585V14.6809C15.5585 15.1039 15.9261 15.4468 16.3796 15.4468C16.8332 15.4468 17.2008 15.1039 17.2008 14.6809V12.1277H18.8432V17.234C18.8432 17.6571 19.2108 18 19.6644 18C20.1179 18 20.4856 17.6571 20.4856 17.234V12.1277H20.9032C21.7777 12.1277 22.2994 11.2186 21.8143 10.5399L18.8945 6.45477C18.6914 6.17066 18.3496 6 17.9835 6H6.01651Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable3);
export default __webpack_public_path__ + "static/media/table-3.a4e0310fdd183f62361bc1ad2cb4147e.svg";
export { ForwardRef as ReactComponent };